import { IAction } from "coral-utility";
import { NavigationItems } from "types";
import { ConnectState } from "state/ducks/connect/types";

export interface NavigationState {
  items: NavigationItems[];
}

export interface DefaultState {
  navigation: NavigationState;
  connect: ConnectState;
}

const navigationActionTypes = {
  GET_NAVIGATION_ITEMS: "GET_NAVIGATION_ITEMS",
  GET_NAVIGATION_ITEMS_SUCCESS: "GET_NAVIGATION_ITEMS_SUCCESS",
  GET_NAVIGATION_ITEMS_FAILURE: "GET_NAVIGATION_ITEMS_FAILURE",
};

export interface NavigationPayload {
  items: NavigationItems[];
}

export interface SetNavigationItemsAction extends IAction {
  payload: NavigationPayload;
}

export type NavigationActionsTypes = IAction | SetNavigationItemsAction;

export default navigationActionTypes;
